<template>
    <v-container style="padding-top: 80px !important">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card v-if="showcargando == false" elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Notificación de presentación</p>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="10" md="10">
                        <v-form ref="form" v-model="validForm" lazy-validation>
                            <v-row justify="center">
                                <v-col cols="12" md="6">
                                    <label class="typo__label">Reporte:</label>
                                    <br>
                                    <label class="typo__label font-weight-bold sub-Fia">
                                        {{ this.datos.nrreporte }}
                                    </label>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Indice:</label>
                                    <br>
                                    <label class="typo__label font-weight-bold sub-Fia">
                                        {{ this.datos.svindice }}
                                    </label>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Folio:</label>
                                    <br>
                                    <label class="typo__label font-weight-bold sub-Fia">
                                        {{ this.datos.fifolio }}
                                    </label>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Afianzadora:</label>
                                    <br>
                                    <label class="typo__label font-weight-bold sub-Fia">
                                        {{ this.datos.afnombre }}
                                    </label>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Conductor:</label>
                                    <br>
                                    <label class="typo__label font-weight-bold sub-Fia">
                                        {{ this.datosNoti.svnomcond }}
                                    </label>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Número de siniestro:</label>
                                    <br>
                                    <label class="typo__label font-weight-bold sub-Fia">
                                        {{ this.datosNoti.svnumsin }}
                                    </label>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Número de Juzgado:</label>
                                    <v-text-field v-model="datosBusqueda.juzgado"
                                        v-on:blur="datosBusqueda.juzgado = datosBusqueda.juzgado != null ? datosBusqueda.juzgado.trim() : null"
                                        outlined :disabled="mostrar || block" :filled="mostrar || block"
                                        :rules="rulestext" @keypress="filter()" :error-messages="validation.juzgado"
                                        maxlength="30" dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <label class="typo__label">Ciudad y Estado del
                                        juzgado:</label>
                                    <v-text-field v-model="datosBusqueda.ciudad"
                                        v-on:blur="datosBusqueda.ciudad = datosBusqueda.ciudad != null ? datosBusqueda.ciudad.trim() : null"
                                        outlined :disabled="mostrar || block" :filled="mostrar || block"
                                        :rules="rulestext" :error-messages="validation.ciudad" maxlength="500" dense>
                                    </v-text-field>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <span class="type-label-style">Fecha de alta:</span>
                                    <v-dialog ref="dialog" outlined v-model="modal"
                                        :return-value.sync="datosBusqueda.selectedDate" persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="date-align-center">
                                                <v-text-field v-model="datosBusqueda.selectedDate" label="" readonly
                                                    outlined dense v-bind="attrs" v-on="on"
                                                    :error-messages="validation.errorFecha"
                                                    ref="datosBusqueda.selectedDate"></v-text-field>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="datosBusqueda.selectedDate" locale="es-mx"
                                            :min="startdate" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="secondary" @click="modal = false">
                                                Cancelar
                                            </v-btn>
                                            <v-btn text color="primary"
                                                @click="$refs.dialog.save(datosBusqueda.selectedDate)">
                                                Aceptar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                    <br />
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Para:</label>
                                    <v-autocomplete solo chips clearable deletable-chips :items="correos.items"
                                        v-model="correos.valor" :search-input.sync="correos.searchIteam"
                                        no-data-text="Introduzca un correo válido" @keyup="addMailValider('correo')"
                                        @change="resetItemsSelector('correo')"></v-autocomplete>
                                    <v-chip class="ma-2" close color="#536DFE" dark
                                        v-for="(chips, chipIndex) in correos.selectedItems" :key="chipIndex"
                                        @click:close="deleteFromList('correo', chips)">
                                        {{ chips }}
                                    </v-chip>
                                    <span v-if="showCorreo" style="color: #FF5C93;"> El campo es obligatorio
                                    </span>
                                    <br>
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">CC:</label>
                                    <v-autocomplete solo chips clearable deletable-chips :items="correosCopia.items"
                                        v-model="correosCopia.valor" :search-input.sync="correosCopia.searchIteam"
                                        no-data-text="Introduzca un correo válido" @keyup="addMailValider('copia')"
                                        @change="resetItemsSelector('copia')"></v-autocomplete>
                                    <v-chip class="ma-2" close color="#536DFE" dark
                                        v-for="(chipscc, chipIndexC) in correosCopia.selectedItems"
                                        :key="chipIndexC + 'cc'" @click:close="deleteFromList('copia', chipscc)">
                                        {{ chipscc }}
                                    </v-chip>
                                    <span v-if="showCopia" style="color: #FF5C93;"> El campo no puede estar vacio
                                    </span>
                                    <br>
                                    <v-divider class="mt-2"></v-divider>
                                    <label class="typo__label">Observaciones:</label>
                                    <v-textarea id="textareaobs"
                                        v-on:blur="datosBusqueda.obs = datosBusqueda.obs.trim()"
                                        v-model="datosBusqueda.obs" class="mt-2 textarea" outlined
                                        :rules="rulestextarea" :error-messages="validation.errorObsDocs">
                                    </v-textarea>
                                    <br>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="ma-2" color="primary" title="Enviar" @click="Aceptar()"> Enviar
                </v-btn>
                <v-btn class="ma-2" v-on:click="limpiar()" color="default">
                    Limpiar
                </v-btn>
                <v-btn color="error" class="ma-2" v-on:click="regresar()">
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
import Fianzas from '@/services/Fianzas/fianzas.service.js';
import moment from "moment";
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            correos: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            correosCopia: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            datosBusqueda: {

                reporte: null,
                indice: null,
                juzgado: null,
                ciudad: null,
                selectedDate: null,
                para: [],
                cc: [],
                obs: null,
                correos: [],
            },
            rulestext: [
                v => {
                    if (v == null || v == '') {
                        return 'El campo es obligatorio'
                    }
                    else {
                        if (v.length < 1) {
                            return 'El campo es obligatorio'
                        }
                        else
                            return true
                    }
                },
            ],
            rulestextarea: [
                //v => !!v || 'Campo requerido',
                (v) => {
                    if (v == "" || v == null) {
                        return "Campo requerido";
                    } else {
                        if (v.trim().length < 12) {
                            return "Mínimo 12 Carácteres";
                        } else if (v.trim().length > 500) {
                            return "Máximo 600 Carácteres";
                        } else {
                            return true;
                        }
                    }
                },
            ],
            validForm: true,
            startdate: '',
            showcargando: true,
            validation: {
                errorFecha: '',
            },


            showCorreo: false,
            showCopia: false,
            //Alta
            modal: false,
            showResp: false,

            datos: null,
            mostrar: false,

            validaradio: false,
            block: false,
            datosNoti: [],
            mailSelected: 0,
            uslogin: '',
        }
    },
    watch: {
        'datosBusqueda.concepto'(val) {
            this.showResp = false;
        },
        'datosBusqueda.radio'(val) {
            this.validaradio = false;
        },
        'correos.selectedItems'(val) {
            this.showCorreo = false;
        },
        'correosCopia.selectedItems'(val) {
            this.showCopia = false;
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        async limpiar() {
            await this.$refs.form.reset();
            this.datosBusqueda.para = [];
            this.datosBusqueda.cc = [];
            this.correos.selectedItems = [];
            this.correosCopia.selectedItems = [];
            this.showCopia = false;
            this.showCorreo = false;
            this.datosBusqueda.selectedDate = moment().format("YYYY[-]MM[-]DD");

        },
        async Aceptar() {
            var errorCounter = 0;
            if (this.correosCopia.selectedItems.length < 1) {
                this.showCopia = true;
                errorCounter++;

            }
            if (this.correos.selectedItems.length < 1) {
                this.showCorreo = true;
                errorCounter++;
            }
            this.$refs.form.validate();
            if (errorCounter == 0 && this.$refs.form.validate()) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let formData = new FormData();
                        formData.append("siniestro", this.datosNoti.svnumsin);
                        formData.append("poliza", this.datosNoti.dapoliza);
                        formData.append("conductor", this.datosNoti.svnomcond);
                        formData.append("juzgado", this.datosBusqueda.juzgado);
                        formData.append("folio", this.datos.fifolio);
                        formData.append("fecha", this.datosBusqueda.selectedDate);
                        formData.append("EstadoCiudad", this.datosBusqueda.ciudad);
                        formData.append("claveAfianzadora", this.datos.afclave);
                        formData.append("nrreporte", this.datos.nrreporte);
                        formData.append("svindice", this.datos.svindice);
                        formData.append("observaciones", this.datosBusqueda.obs);
                        formData.append("copias", this.correosCopia.selectedItems);
                        formData.append("correos", this.correos.selectedItems);
                        formData.append("uslogin", this.uslogin);


                        let response = await Fianzas.ProcesoNotificacion(formData);
                        if (response) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se notificó la fianza correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
                                this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error, al notificar la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }
                    }
                });
            }
        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();
            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async regresar() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
        },
        addMailValider(tipo) {
            var regex = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;
            if (tipo == 'correo') {
                if (regex.test(this.correos.searchIteam)) {
                    this.correos.items = [
                        {
                            value: this.correos.searchIteam,
                            text: this.correos.searchIteam,
                        },
                    ];
                    this.valcorreo = false;
                }
            } else if (tipo == 'copia') {
                if (regex.test(this.correosCopia.searchIteam)) {
                    this.correosCopia.items = [
                        {
                            value: this.correosCopia.searchIteam,
                            text: this.correosCopia.searchIteam,
                        },
                    ];
                }
            }
        },
        deleteFromList(tipo, item) {
            if (tipo == 'correo') {
                this.correos.selectedItems = this.correos.selectedItems.filter((element) => element !== item);
                if (this.correos.selectedItems.length == 0) {
                    this.correos.valor = null;
                }
            } else if (tipo == 'copia') {
                this.correosCopia.selectedItems = this.correosCopia.selectedItems.filter((element) => element !== item);
                if (this.correosCopia.selectedItems.length == 0) {
                    this.correosCopia.valor = null;
                }
            }

        },
        resetItemsSelector(tipo) {
            if (tipo == 'correo') {
                if (this.correos.valor != null) {
                    this.mailSelected++;
                    this.correos.selectedItems.push(this.correos.valor);
                    this.correos.searchIteam = null;
                    this.correos.items = null;
                }
            } else if (tipo == 'copia') {
                if (this.correosCopia.valor != null) {
                    this.mailSelected++;
                    this.correosCopia.selectedItems.push(this.correosCopia.valor);
                    this.correosCopia.searchIteam = null;
                    this.correosCopia.items = null;
                }
            }
        },
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "15,317").then((response) => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 15)//acceso al módulo de contraloría Normativa 
                        this.permisoContraloria = true;
                    if (permiso.peclave == 317)//Permiso para fianzas
                        this.permisoFianzas = true;
                })

                if (!this.permisoContraloria || !this.permisoFianzas) {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('fianza');
        this.uslogin = await MetodosGenerales.ObtenerUserName();

        var formData = new FormData();
        formData.append("afianzadora", this.datos.afclave);
        formData.append("folio", this.datos.fifolio);
        this.datosNoti = await Fianzas.NotificacionPresentacion(formData);

        this.startdate = moment().format("YYYY[-]MM[-]DD");
        this.datosBusqueda.selectedDate = moment().format("YYYY[-]MM[-]DD");

        if (this.datosNoti.svjuzgado != null && this.datosNoti.svjuzgado != "") {
            this.datosBusqueda.juzgado = this.datosNoti.svjuzgado;
        }

        if (this.datosNoti.premail != null) {
            var subs = this.datosNoti.premail.split(';');
            if (subs.length == 1) {
                this.correosCopia.selectedItems.push(this.datosNoti.premail);
            }
            else {
                for (var i = 0; i <= subs.length; i++) {
                    if (subs[i] != undefined) {
                        this.correosCopia.selectedItems.push(subs[i]);
                    }
                }
            }
        }

        if (this.datosNoti.clcorreoalertas != null) {
            var subs = this.datosNoti.clcorreoalertas.split(';');
            if (subs.length == 1) {
                this.correosCopia.selectedItems.push(this.datosNoti.clcorreoalertas);
            }
            else {
                for (var i = 0; i <= subs.length; i++) {
                    if (subs[i] != undefined) {
                        this.correosCopia.selectedItems.push(subs[i]);
                    }
                }
            }
        }

        if (this.datosNoti.gecorreogerente != null) {
            var subs = this.datosNoti.gecorreogerente.split(';');
            if (subs.length == 1) {
                this.correosCopia.selectedItems.push(this.datosNoti.gecorreogerente);
            }
            else {
                for (var i = 0; i <= subs.length; i++) {
                    if (subs[i] != undefined) {
                        this.correosCopia.selectedItems.push(subs[i]);
                    }
                }
            }
        }

        if (this.datosNoti.suemail != null) {
            var subs = this.datosNoti.suemail.split(';');
            if (subs.length == 1) {
                this.correosCopia.selectedItems.push(this.datosNoti.suemail);
            }
            else {
                for (var i = 0; i <= subs.length; i++) {
                    if (subs[i] != undefined) {
                        this.correosCopia.selectedItems.push(subs[i]);
                    }
                }
            }
        }
        this.showcargando = false;
    },
}
</script>

<style scoped>
.sub-Fia {
    font-size: 18px;
}
</style>
